import createCustomApp from '@/views/init-app.js';
import MainPage from '@/views/ProjectOverview.vue';

const domId = 'project-query';

createCustomApp(MainPage, domId);
